import classNames from 'classnames'
import DotsLoading from 'components/loadings/dotsLoading'
import useGetBankAccounts from 'pages/bankAccounts/hooks/useGetBankAccounts'
import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { BankConvertor } from 'utilities/helper/banksConvertor'
interface IModalProps {
    show: boolean
    onHide: () => void
    setSelectedCard: React.Dispatch<
        React.SetStateAction<IBankCardsResult | undefined>
    >
    selectedCard: IBankCardsResult | undefined
}
export default function MyWalletModals({
    show,
    onHide,
    setSelectedCard,
    selectedCard,
}: IModalProps) {
    const navigate = useNavigate()
    const { data } = useGetBankAccounts()
    useEffect(() => {
        if (data) {
            data.pages
                .flatMap((x) => x.results)
                .map((item) => item.is_default && setSelectedCard(item))
        }
    }, [data])
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" py-3 px-2 text-sm">
                <p className=" text-center text-sm">
                    یک شماره حساب را به عنوان حساب اصلی صندوق انتخاب کنید:
                </p>
                <hr className=" my-2" />
                <button
                    type="button"
                    className="bg-green-main text-green-1  rounded-md py-2 my-2 w-full text-sm"
                    onClick={() => navigate('/manage-bank-cards/add')}
                >
                    ثبت شماره حساب جدید
                </button>
                {data ? (
                    <div className=" h-96 overflow-y-scroll">
                        {data.pages
                            .flatMap((x) => x.results)
                            .map((item) => (
                                <div
                                    className={classNames(
                                        ' flex justify-start rounded-lg py-2 px-3 items-center  my-2 bg-gray-5',
                                        item.is_default && 'bg-[#EFF7E9]'
                                    )}
                                    onClick={() => {
                                        setSelectedCard(item)
                                        onHide()
                                    }}
                                    key={item.id}
                                >
                                    <img
                                        src={
                                            BankConvertor[item.bank_unique_code]
                                        }
                                        alt="bank"
                                        className=" w-10 h-10"
                                    />
                                    <div className=" mr-3">
                                        <p>{item.full_name}</p>
                                        <p className=" mt-2">
                                            {item.card_number
                                                ? item.card_number
                                                      .match(/.{1,4}/g)
                                                      ?.join(' ')
                                                : item.iban
                                                      .match(/.{1,4}/g)
                                                      ?.join(' ')}
                                        </p>
                                    </div>
                                </div>
                            ))}
                    </div>
                ) : (
                    <DotsLoading />
                )}

                <div>
                    <hr className=" my-2" />
                    <p
                        className=" text-green-1 text-center"
                        onClick={() => {
                            if (selectedCard) {
                                onHide()
                            } else {
                                toast.error('حساب اصلی صندوق را انتخاب کنید')
                            }
                        }}
                    >
                        تایید
                    </p>
                </div>
            </div>
        </Modal>
    )
}
